// IEshit issues
// import 'core-js';

// Style
import './style/style.scss';

// Jquery
//import $ from 'jquery';
//**import loopExample from './templateExample';

import $ from "jquery";


// import article from './templates/pages/article';
// import frontpage from './templates/pages/frontpage';
// import content from './templates/pages/content';
// import header from './templates/body/header';
// import footer from './templates/body/footer';
// import list from './templates/pages/list';
// import nav from './templates/body/nav';
// import show404 from './templates/pages/status_404.js';
// import headerMenu from './templates/body/header_menu.js';
// import { headerNav, storeNav, navPage } from "./scripts/nav.js"
// import fullsearch from './templates/pages/search';
// import event from './templates/pages/event.js';
import "fantdu/dist/fantdu.min";
// import { skjema_page } from "./scripts/skjema.js";
// import { convertJSON } from "./scripts/convertjson.js";
import { startMeUp } from "./scripts/startscript.js";
import { cookieRead, cookieDelete } from "./scripts/cookie_control";
import deepmerge from "./scripts/tools/deepMerge";
// Template literal example, look in the templateExample.js
//**const html = loopExample("hallo verden");


if(window.location.host.match(".aim")){
    var robots = document.createElement('meta');
    robots.name = "robots";
    robots.content = "noindex";
    document.head.appendChild(robots);
}

window.getUrlAttr = function(attr) {
    return new URL(window.location.href).searchParams.get(attr);
}

window.apiUrl = "https://prokom-aimcms.azurewebsites.net";
window.dev = false;

if (window.location.href.match(/\?dev/gi)) {
    window.apiUrl = "https://prokom-aimcms-qa.azurewebsites.net";
    window.dev = true;
}

// console.log(getUrlAttr("runtimemode"));

if (cookieRead("RuntimeMode") == "dev") {
    console.log("qa");
    window.apiUrl = "https://prokom-aimcms-dev.azurewebsites.net";
    window.dev = true;
}

if (cookieRead("RuntimeMode") == "qa") {
    console.log("qa");
    window.apiUrl = "https://prokom-aimcms-qa.azurewebsites.net";
    window.dev = true;
}

if (cookieRead("RuntimeMode") == "staging") {
    window.apiUrl = "https://prokom-aimcms-staging.azurewebsites.net";
    window.dev = true;
}

if (cookieRead("RuntimeMode") == "release") {
    window.apiUrl = "https://prokom-aimcms-release.azurewebsites.net";
    window.dev = true;
}

if (cookieRead("RuntimeMode") == "prod") {
    window.apiUrl = "https://prokom-aimcms.azurewebsites.net";
    window.dev = true;
}

window.contentID = "";
window.contentSubscription = "";

let host = window.location.host;


if (host.match("aim")) {
    if (host.split(".aim")) {
        let domain = host.split(".aim")[0];

        if (domain.match(/\./gi)) {
            domain = domain.split(".")[1];
        }

        sessionStorage.setItem("kommune", domain);
    }
}
if (host.match(".kommune.no")) {
    let domain = host.split(".kommune")[0];

    if (domain.match(/\./gi)) {
        domain = domain.split(".")[1];
    }

    sessionStorage.setItem("kommune", domain);
}

window.urlify = (string) => {
    if (string !== null) {
        string = string.replace(/\s|\,|-/gi, "_").replace(/[æå]/gi, "a").replace(/[ø]/gi, "o").replace(/[_]{2,}/gi, "").toLowerCase();
    }
    return string;
}

window.getPageUrl = function() {
    let urldivert = location.pathname.substr(1).split(/\/(.+)/);
    let template = urldivert[0] || "frontpage";
    let contentid = urldivert[1] || "";
    return { template: template, contentid: contentid, path: urldivert };
}

if (document.referrer.match(/(https:\/\/aim-admin.azurewebsites.net)/gi)) {
    sessionStorage.setItem("fromcms", true);
}

// if (!sessionStorage.getItem("kommune") || (window.getUrlAttr("kommune") && sessionStorage.getItem("kommune") != decodeURIComponent(window.getUrlAttr("kommune")))) {
//     sessionStorage.setItem("kommune", decodeURIComponent(window.getUrlAttr("kommune")));
// }
// let kommune = sessionStorage.getItem("kommune") || "prokom";

// const colors = Object.assign(defaultcolors, infoscreen.colors);

window.translation = {}

document.addEventListener('DOMContentLoaded', function(e) {
    const data = { "clientDomainName": window.location.hostname };
    window.matchApplication = "1086ee5d-24b8-42bf-842f-5fe1dca688cf"; // kariadmin

    // console.log(data);

    let munic;
    const d = window.location.host;
    munic = d.replace(/\.aim\.prokom\.no|\.kommune\.no/gmi, "");
    if (munic.match(/\./gmi))
        munic = munic.split(".")[1];
    else if (munic.match(/localhost:\d{4}/gmi)) {
        munic = "noreoguvdal";
        sessionStorage.setItem("kommune", munic);
    }

    // console.log(`[ catch municipality: ${munic} ]`);
    munic = munic.replace(/\-/gmi,"");
    // console.log(munic);
    // console.log("is is alive 2");

    let initialPromise = [];
    
    initialPromise.push(
        new Promise((resolve, reject) => {
            if (window.location.host.match(/localhost:\d{4}/gim)) {
                const data = { clientDomainName: `${munic}.aim.prokom.no` };
                fetch(
                'https://rolemanager.prokom.no/api/admin/organization/getclientbydomain',
                {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }
                )
                .then((response) => response.json())
                .then((data) => {
                    if (data.result) {
                    resolve(data);
                    }
                });
            } else {
                fetch("//config.aim.prokom.no/clients/configbackup/" + munic + ".aim.prokom.no.json", { headers: { "Content-Type": "application/json; charset=utf-8" } })
                    .then(response => response.json())
                    .then(data => {
                        if (data.result) {
                            resolve(data);
                        }
                    })
            }
        })
    )

    initialPromise.push(
        new Promise((resolve, reject) => {
            fetch("//config.aim.prokom.no/clients/configbackup/ummo.aim.prokom.no.json", { headers: { "Content-Type": "application/json; charset=utf-8" } })
                .then(response => response.json())
                .then(data => {
                    if (data.result) {
                        data.result.applications.forEach((appMeta) => {
                            // console.log(appMeta);
                            let meta;
                            if (appMeta.application.applicationServiceLocalId === "aim") {
                                meta = JSON.parse(decodeURIComponent(appMeta.metaData));
                            }
                            else if (appMeta.application.applicationServiceLocalId === "KariAdm") {
                                meta = JSON.parse(decodeURIComponent(appMeta.metaData));
                            }
                            resolve(meta.translation);
                        })
                    }
                })
        })
    )

    Promise.all(initialPromise).then(elm => {
        // console.log("all promises");
        const config = elm[0];
        let localTranslation = {};
        // console.log(localTranslation);
        config.result.applications.forEach((appMeta) => {
            // console.log(appMeta);
            let meta;
            if (appMeta.application.applicationServiceLocalId === "aim") {
                meta = JSON.parse(decodeURIComponent(appMeta.metaData));
            }
            else if (appMeta.application.applicationServiceLocalId === "KariAdm") {
                meta = JSON.parse(decodeURIComponent(appMeta.metaData));
            }
            if(meta.translation !== undefined){
                // console.log("test", meta.translation);
                localTranslation = meta.translation;
            }
        })
        // console.log(localTranslation);
        let translation = elm[1];
        // console.log(localTranslation, translation);
        let joined = deepmerge(translation, localTranslation);
        // console.log(joined);
        window.translation = joined;
        console.log("starting site");
        startMeUp(config, e);
    })
});
